import { useForm } from "@mantine/form";
import { validateRequired } from "../../../utils/validations";
import { Button, TextInput } from "@mantine/core";
import { Skill } from "../../../types/types";
import { updateNotification } from "../../../utils/useNotification";
import { updateSkillById } from "../../../api/skillApi";

const SkillUpdateForm = ({
  skill,
  closeModal,
  updateSkillList,
}: {
  skill: Skill;
  closeModal: any;
  updateSkillList: any;
}) => {
  const form = useForm<any>({
    initialValues: {
      name: skill?.name,
      description: skill?.description,
    },
    validate: {
      name: validateRequired,
      description: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { data }: any = await updateSkillById({
        id: skill?._id,
        updates: values,
      });
      if (data?.success) {
        updateNotification(data?.success);
        updateSkillList();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      closeModal();
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <TextInput
        label="Yetenek İsmi"
        placeholder="Yetenek İsmi Giriniz."
        radius={10}
        maxLength={40}
        size="md"
        {...form.getInputProps("name")}
      />
      <TextInput
        label="Yetenek Açıklaması"
        placeholder="Yetenek Açıklaması Giriniz."
        radius={10}
        maxLength={140}
        size="md"
        {...form.getInputProps("description")}
      />

      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty()}
      >
        Güncelle
      </Button>
    </form>
  );
};

export default SkillUpdateForm;
